import fetch from "@/utils/fetch2";

export function getPublishList(params) {
  return fetch({
    // url: 'System/System/saveDataDictionary',
    url: "manage/getPublishList",
    method: "post",
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/pgMent/publishMent.js